import { extendTheme } from '@chakra-ui/react';

const customTheme = extendTheme({
    fonts: {
        heading: `'Plus Jakarta Sans', 'Noto Sans Armenian', -apple-system, sans-serif`,
        body: `'Plus Jakarta Sans', 'Noto Sans Armenian', -apple-system, sans-serif`,
    },
    colors: {
        brand: {
            50: '#eff6ff',
            100: '#dbeafe',
            200: '#bfdbfe',
            300: '#93c5fd',
            400: '#60a5fa',
            500: '#2563eb', // modern blue
            600: '#1d4ed8',
            700: '#1e40af',
            800: '#1e293b',
            900: '#0b132b', // deep midnight navy
        },
        gold: {
            100: '#fdf8ef',
            200: '#f5e8cd',
            300: '#e9d3a4',
            400: '#dfba73',
            500: '#c5a880',
            600: '#a8885b',
            700: '#8c6b3e',
        },
        surface: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            800: '#1e293b',
            900: '#0f172a',
        }
    },
    components: {
        Button: {
            baseStyle: {
                fontWeight: '600',
                borderRadius: 'lg',
                transition: 'all 0.25s ease',
            },
            variants: {
                solid: {
                    bg: 'brand.600',
                    color: 'white',
                    _hover: {
                        bg: 'brand.500',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 8px 20px -4px rgba(29, 78, 216, 0.4)',
                    },
                },
                gold: {
                    bg: 'linear-gradient(135deg, #dfba73 0%, #c5a880 100%)',
                    color: '#0b132b',
                    fontWeight: '700',
                    _hover: {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 8px 20px -4px rgba(197, 168, 128, 0.5)',
                    },
                },
                outline: {
                    borderColor: 'brand.500',
                    color: 'brand.600',
                    _hover: {
                        bg: 'brand.50',
                    },
                },
                ghost: {
                    _hover: {
                        bg: 'whiteAlpha.200',
                    },
                },
            },
        },
        Heading: {
            baseStyle: {
                letterSpacing: '-0.02em',
                fontWeight: '700',
            },
        },
    },
    styles: {
        global: {
            'html, body': {
                backgroundColor: '#f8fafc',
                color: '#1e293b',
                margin: 0,
                padding: 0,
            },
        },
    },
});

export default customTheme;
